import { showClockPath, showDebugLabelsPath } from "./helper";
import { DebugSlice } from "./types";

const storedShowDebugLabels = localStorage.getItem(showDebugLabelsPath);
const initialShowDebugLabels = storedShowDebugLabels
	? JSON.parse(storedShowDebugLabels)
	: false;

const storedShowClock = localStorage.getItem(showClockPath);
const initialShowClock = storedShowClock ? JSON.parse(storedShowClock) : false;

export const initialState: DebugSlice = {
	showDebugLabels: initialShowDebugLabels,
	showClock: initialShowClock,
	debugEnabled: {
		success: false,
		errorMessage: "",
		enabled: false
	}
};
